<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Listado de Empleados
            br
            router-link.a.button.is-dark.is-rounded.is-size-6.is-rounded.is-medium(to="/Inventario/NuevoEmpleado") Nuevo Empleado
            br
        .columns(v-show="hayDatos")
          .column.is-10.is-offset-1.has-text-centered
            table#tbEmpleados.table.is-striped
              thead
                tr
                  th #
                  th Nombre
                  th Departamento
                  th Ubicación
                  th Cargo
              tbody
                tr(v-for="(data, index) in empleados" :key="data.id")
                  td 
                    a.button.is-primary(@click="irAltaDetalle(data.id)") {{ index + 1 }} 
                  td {{ data.nombre }} 
                  td {{ getDepto(data) }}
                  td 📌 {{ data.ubicacion }}
                  td {{ data.cargo }}
        .columns(v-show="!hayDatos")
          .column.is-4.is-offset-4
            .notification.is-danger No existen Registros aún en la Base de Datos.
</template>

<script>
import Loader from '../shared/Loader.vue'
import HeaderInventario from './layout/HeaderInventario.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'

export default {
  name: 'Empleados',
  components: { Loader, NavBarInventario, HeaderInventario },
  data () {
    return {
      isLoading: true,
      empleados: [],
      hayDatos: false,
      tipos: []
    }
  },
  methods: {
    obtenerDataEmpleados() {
      InventarioServices.getEmpleados()
        .then(res => {
          this.empleados = res.data
          console.log(this.empleados.length)
          if (this.empleados.length > 0) {
            this.hayDatos = true
          } else {
            this.hayDatos = false
          }
          setTimeout(() => {
            this.isLoading = false
          }, 1000);
        })
    },
    getDepto (data) {
      switch (data.departamento) {
        case '0':
          return 'Gerencia'
          break;
        case '1':
          return 'Operaciones'
          break;
        case '2':
          return 'Mantenimiento'
          break;
        case '3':
          return 'Seguridad'
          break;
        case '4':
          return 'Administración'
          break;
        case '5':
          return 'Instrumentación'
          break;
        case '6':
          return 'Sistemas'
          break;
      
        default:
          break;
      }
    }
  },
  created () {
    this.obtenerDataEmpleados()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/Empleados.vue